import Joi from 'joi';

import { createIndividualAccountContactSchema } from '../../../contacts/validators/schemas/create-individual-account-contact.schema';
import { createProtoDriverSchema } from '../../../drivers/validators/schemas/create-proto-driver.schema';
import { AccountTypeEnum } from '../../enums/account-type.enum';

/**
 * Schema for new account record validation.
 */
export const createAccountSchema = () =>
	Joi.object({
		// Type
		type: Joi.alternatives()
			.conditional(Joi.any().valid(null), {
				then: Joi.invalid(null).messages({
					'any.invalid': 'validations|account-type|cannot-be-null',
				}),
				otherwise: Joi.string()
					.valid(AccountTypeEnum.INDIVIDUAL)
					.required()
					.messages({
						'any.required': 'validations|account-type|required',
						'any.only': 'validations|account-type|invalid-value',
					}),
			})
			.prefs({ abortEarly: true }),

		// Contact
		contact: createIndividualAccountContactSchema(18),

		// Driver
		driver: createProtoDriverSchema(),
	})
		// Ignore extra fields
		.unknown();
